/** @format */
import classnames from "classnames";
import { ReactComponent as Image } from "../../assets/images/logo.svg";

export default function Icon(props) {
  let colorInvert = props.colorInvert || false;
  return <Image className={classnames(colorInvert ? "invert" : "")} />;
}
